export default __webpack_public_path__ + "static/media/audio5.2921fb97.vtt";